import loginImg from "../assets/Images/Loginpage.webp"
import Template from "../components/core/Auth/Template"
import { login } from "../services/operations/authAPI"
import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import { TbCornerDownRightDouble } from "react-icons/tb"
import { BsLightningChargeFill } from "react-icons/bs"
import {  AiOutlineClose } from "react-icons/ai";
function Login() {
  const [showDemo, setShowDemo] = useState(true)
  const dispatch = useDispatch()
  const navigate = useNavigate()
  return (
<div className="bg-blue-150 h-full" >

 {/* test login ID */}
 <div  className={`${showDemo ? "":"hidden"} justify-center items-center absolute bg-richblack-400 top-52 md:top-32 md:right-[50%] right-[10%] p-6 -rotate-[20deg] z-20 `}>

      <div className="flex flex-col gap-2 relative">
        <div onClick={()=>{setShowDemo(false)}} className="absolute top-[-30px] right-[-20px] text-5xl text-richblack-900 rounded-full w-[40px] h-[40px] flex justify-center items-center cursor-pointer">
        {/* <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="20" height="20">
  <circle cx="50" cy="50" r="45" fill="#888888" stroke="#000000" stroke-width="2" />
  <circle cx="50" cy="50" r="20" fill="#ffffff" />
</svg> */}

<span className="text-white font-semibold text-[20px] " ><AiOutlineClose></AiOutlineClose></span>

        </div>

        <div className=" gap-y-2 flex flex-col">
        <p className="text-2xl font-extrabold text-pink-800 flex items-center">Take a Demo &nbsp; <BsLightningChargeFill size={20}/></p>
        <div>
        <button onClick={
          () => {
            dispatch(login("uky0027@gmail.com", "Yadav$0027", navigate)
          )}
        } className="bg-blue-100 font-semibold mt-4 mb-1 text-richblack-900 px-4 py-2 rounded-md flex">
          <TbCornerDownRightDouble className="text-2xl text-white hidden md:block"/>
          Click here for Instructor Demo</button>
      </div>
      <div>
        <button onClick={
          () => {
            dispatch(login("Rahul123456@gmail.com", "123456", navigate)
          )}
        } className="bg-blue-100 font-semibold text-richblack-900 px-4 py-2 rounded-md flex">
          <TbCornerDownRightDouble className="text-2xl text-white md:block hidden"/>
          Click here for Student Demo</button>
        </div>
        </div>
      </div>
    </div>

    <button 
  onClick={() => { setShowDemo(true); }} 
  className={`
    ${showDemo ? "hidden" : ""} 
    text-white 
    font-semibold 
    bg-blue-50
    justify-center items-center 
    absolute 
    top-60 md:top-32 md:right-[50%] right-[20%] 
    px-8 py-4 
    transform rotate-[20deg] 
    z-20 
    rounded-lg 
    shadow-lg 
    transition-all duration-300 ease-in-out 
    hover:scale-105 hover:shadow-xl hover:bg-gradient-to-r hover:from-pink-600 hover:to-pink-600
  `}
>
  Show Demo
</button>


    {/* <button  onClick={()=>{setShowDemo(true)}} className={`${showDemo ? "hidden":""} text-richblack-800 font-medium bg-richblack-400 justify-center items-center absolute  top-60 md:top-32 md:right-[50%] right-[20%] px-8 py-4 -rotate-[20deg] z-20`}>Show Demo</button> */}

    
<div className="bg-blue-150">
      <Template
      title="Welcome Back"
      description1="Build skills for today, tomorrow, and beyond."
      description2="Education to future-proof your career."
      image={loginImg}
      formType="login"

      
    />
    
  </div>
  
 
</div>
  )
}

export default Login

